	import React,{Fragment, Component} from 'react';
	import {Link} from 'react-router-dom';
	import WOW from 'wowjs';
	import { gsap } from 'gsap';
	import SimpleReactLightbox,{SRLWrapper, useLightbox} from 'simple-react-lightbox';
	import Header2 from './../../Layout/Header2';
	import FooterPremium from './../../Layout/FooterPremium';
	import {ExhibitionSection} from './../CompanyExhibition';
	import { CounterSection ,TeamSection, SpondorSection, VideoSection} from './../Aboutus/Aboutus2';
	import {GalleryBox} from './../Portfolio/Portfolio1';
	import BannerSlider from './BannerSlider';
	import Slider1 from './../../Element/Slider1';
	import EventSection from './EventSection';
	import VideoPopup from './../../Element/VideoPopup';
	//images 
	import port1 from './../../../images/portfolio/portfolio-box/pic1.jpg';
	import port2 from './../../../images/portfolio/portfolio-box/pic2.jpg';
	import port3 from './../../../images/portfolio/portfolio-box/pic3.jpg';
	import port4 from './../../../images/portfolio/portfolio-box/pic4.jpg';
	import port5 from './../../../images/portfolio/portfolio-box/pic5.jpg';
	import colrimg1 from './../../../images/banner/time.png';
	import colrimg2 from './../../../images/banner/time.png';
	import colrimg3 from './../../../images/banner/time.png';
	// Banner images for projects
	import banner1 from './../../../images/banner/banner1.png';
	import banner2 from './../../../images/banner/img1.jpg';
	import banner3 from './../../../images/banner/img3.jpg';
	import spec1 from './../../../images/banner/img1.jpg';
	import spec2 from './../../../images/banner/img2.jpg';
	import spec3 from './../../../images/banner/img3.jpg';
	import main1 from './../../../images/banner/img1.jpg';
	import main2 from './../../../images/banner/img2.jpg';
	import main3 from './../../../images/banner/img3.jpg';
	import main4 from './../../../images/banner/img4.jpg';
	import main5 from './../../../images/banner/img1.jpg';
	import main6 from './../../../images/banner/img2.jpg';
	import gallery1 from './../../../images/banner/img1.jpg';
	import gallery2 from './../../../images/banner/img2.jpg';
	import gallery3 from './../../../images/banner/img3.jpg';
	import gallery4 from './../../../images/banner/img4.jpg';
	import gallery5 from './../../../images/banner/img1.jpg';
	import gallery6 from './../../../images/banner/img2.jpg';
	// Selected project images
	import towera from './../../../images/banner/towera.png';
	import towerb from './../../../images/banner/towerb.png';
	import views1 from './../../../images/banner/views1.png';
	import views2 from './../../../images/banner/views2.png';
	import TowerC from './../../../images/banner/TowerC.jpg';
	import executive from './../../../images/banner/executive.png';
	// Slider image
	import SliderImg from './../../../images/main-slider/newslide.png';
	// Banner video
	import BannerVideo from './../../../images/main-slider/bannervideo.mp4';
import SpecificationsBlog from './SpecificationsBlog';
import SwiperSlider from './../Aboutus/SwiperSlider';
import AwardSection from './AwardSection';

const Footer2 = FooterPremium;

	const ServiceBlog = ({serviceImage, serviceTitle, serviceText = "To Ajman City Center"}) =>{
		return(
			<div className="icon-bx-wraper sr-iconbox">
				<div className="icon-lg m-b20">
					<Link to={"#"} className="icon-cell"><img src={serviceImage} alt=""/></Link>
				</div>
				<div className="icon-content">
					<h2 className="dlab-tilte">{serviceTitle}</h2>
					<p>{serviceText}</p>
				</div>
			</div>
		)
	} 

	const ProjectTagLi = ({label, value, handleSetTab, tabActive}) => {
		return (
			<li className={`tag ${tabActive ? 'btn active' : 'btn'}`} onClick={() => handleSetTab(value)}>
				<input type="radio" />
				<Link to={"#"} className="site-button-secondry button-skew">
					<span>{label}</span>
				</Link>
			</li>
		);
	};

	class Index2 extends Component{
		constructor(props) {
			super(props);
			this.state = {
				activeTab: 'completed'
			};
		}
		
	componentDidMount(){
		// Initialize WOW.js with smooth animation settings
		new WOW.WOW({
			boxClass: 'wow',
			animateClass: 'animated',
			offset: 100,
			mobile: true,
			live: true,
			scrollContainer: null,
			resetAnimation: false
		}).init();
		
		// Banner text animation - Smooth reveal like KingArchitect
		this.initBannerAnimations();
		
		// Gallery image change functionality
		var GalleryCategory = document.querySelectorAll('.gallery-category .items');
		var GalelryMedia = document.querySelectorAll('.gallery-img img');
		
		var fch = [].slice.call(GalleryCategory);
		var fcMedia = [].slice.call(GalelryMedia);
		
		for (var y = 0; y < fch.length; y++) {
			fch[y].addEventListener('mouseenter', function () { 
				galleryActive(this);
			});
		}
		
		function galleryActive(current) 
		{
			fcMedia.forEach(el => el.classList.remove('active'));
			
			setTimeout(() => {
				var dataImageBx = current.getAttribute('data-image-bx'); 
				document.querySelector('#'+dataImageBx).classList.add('active');
			}, 100);
		}
	}
		
		handleTabChange = (tab) => {
			this.setState({ activeTab: tab });
		}
		
		initBannerAnimations = () => {
			// Wait for DOM to be ready
			setTimeout(() => {
				// Create timeline for smooth banner text animation - KingArchitect style
				const bannerTl = gsap.timeline({ defaults: { ease: 'power3.out' } });
				
				// Split the title into lines for staggered animation
				const titleLines = document.querySelectorAll('.banner-title-line');
				const bannerButton = document.querySelector('.banner-button');
				const videoPopup = document.querySelector('.banner-video-popup');
				
				if (titleLines.length > 0) {
					// Animate each line separately with smooth slide and fade - like KingArchitect
					titleLines.forEach((line, index) => {
						gsap.set(line, { 
							opacity: 0, 
							y: 100,
							x: -50,
							rotationX: -15
						});
						
						bannerTl.to(line, {
							duration: 1.4,
							opacity: 1,
							y: 0,
							x: 0,
							rotationX: 0,
							ease: 'power3.out',
							delay: index * 0.2
						}, index === 0 ? 0.5 : '-=1.0');
					});
				} else {
					// Fallback: animate the entire title if lines aren't split
					const title = document.querySelector('.banner-content .title');
					if (title) {
						gsap.set(title, { opacity: 0, y: 100, x: -50 });
						bannerTl.to(title, {
							duration: 1.4,
							opacity: 1,
							y: 0,
							x: 0,
							ease: 'power3.out'
						}, 0.5);
					}
				}
				
				// Animate button with smooth entrance
				if (bannerButton) {
					gsap.set(bannerButton, { opacity: 0, y: 40, scale: 0.85 });
					bannerTl.to(bannerButton, {
						duration: 1.0,
						opacity: 1,
						y: 0,
						scale: 1,
						ease: 'back.out(1.4)'
					}, '-=0.6');
				}
				
				// Animate video popup button
				if (videoPopup) {
					gsap.set(videoPopup, { opacity: 0, scale: 0, rotation: -180 });
					bannerTl.to(videoPopup, {
						duration: 0.8,
						opacity: 1,
						scale: 1,
						rotation: 0,
						ease: 'back.out(1.6)'
					}, '-=0.4');
				}
			}, 100);
		}
		
		render(){
			return(
				<Fragment>
					<style>{`
						@media (max-width: 991px) {
							.banner-three {
								    background-size: cover;
    
	    background-position: center!important;
							}
							.banner-three::before {
								content: '';
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								background: linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.4) 100%);
								z-index: 1;
							}
							.banner-three .banner-content .title,
							.banner-three .banner-content .title .banner-title-line {
								color: #ffffff !important;
							}
						}
						@media (min-width: 992px) {
							.header-nav .nav > li > a {
								color: #ffffff !important;
							}
						}
						.site-header .main-bar {
							background: #000000 !important;
						}
					`}</style>
					<Header2 />
					{/* <!-- Main Slider --> */}
				<div className="page-content bg-white">
					<div className="banner-three" data-content="HOME" id="sidenav_home" style={{position: 'relative', overflow: 'hidden'}}>
						<video 
							autoPlay 
							loop 
							muted 
							playsInline
							style={{
								position: 'absolute',
								top: 0,
								left: 0,
								width: '100%',
								height: '100%',
								objectFit: 'cover',
								zIndex: 0
							}}
						>
							<source src={BannerVideo} type="video/mp4" />
						</video>
						<div className="container" style={{position: 'relative', zIndex: 2}}>
							<div className="row align-items-center banner-inner " >
								<div className="col-md-6">
									<div className="content-blog">
										<div className="banner-content">
											<h1 className="title m-b20">
												<span className="banner-title-line">Why Rent When You</span>
												<br/>
												<span className="banner-title-line">Can Own an Apartment?</span>
												<br/>
												<span className="banner-title-line">acquainted</span>
											</h1>
											{/* <Link to={"/contact-us-1"} className="btn btn-primary banner-button">Book A Site Visit</Link> */}
										</div>
										
									</div>	
								</div>
							</div>
						</div>
					</div>	
					{/* <!-- Main Slider End--> */}
					{/* <div className="main-slider style-two default-banner" id="home">
						<div className="tp-banner-container">
							<div className="tp-banner" >
								<BannerSlider />	
							</div>
						</div>	
					</div>	 */}
					{/* Award Section */}
				
				
					{/* Content */}
						<div className="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
							<AwardSection />
						</div>
				</div>
				<div className="page-content bg-white">
						<div className="content-block">
							{/*  About Us */}
							{/* <section className="content-inner exhibition-bx" data-content="ABOUT US" >
								<div className="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
									<ExhibitionSection />
								</div>
							</section> */}
							{/*  About Us  End*/}
							

	{/* Section-2  Start*/}
					{/* <section className="content-inner-2" data-content="SPECIFICATIONS" id="sidenav_specifications">				
						<div className="container">
							<div className="section-head head-col wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.1s">
								<h2 className="title" >Specifications</h2>
								<p>Discover the premium features and world-class specifications of Goldcrest properties. Each development is designed with meticulous attention to detail, offering modern amenities, superior construction quality, and luxurious finishes that define contemporary living in the UAE.</p>
							</div>
						</div>
						<section className="amenities-area wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.1s">
							<Slider1 /> 
						</section>
						<div className="row faqs-box spno wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
							<div className="col-md-8 col-lg-8 col-xl-8">
								<div className="faq-media">
									<Link to={"#"}><img src={spec1} id="Capmap1" className="active" alt=""/></Link>
									<Link to={"#"}><img src={spec2} id="Capmap2" alt=""/></Link>
									<Link to={"#"}><img src={spec3} id="Capmap3" alt=""/></Link>
								</div>
							</div>
							<SpecificationsBlog />
						</div>
					</section>	 */}
					{/* Section-2 End */}





	

	{/* Section-3 Start */ }
	<section className="content-inner-1" data-content="" id="masterPlan">				
						<div className="container">
							<div className="section-head text-center wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.1s">
								<h2 className="title">Site Plan &amp; Master Plan</h2>
								<div className="dlab-separator bg-primary"></div>
								<p>Explore our concise site and master plan for Goldcrest, designed for efficient space, natural light, and community connectivity. Layouts, amenities, and specifications are conceptual and may vary.</p>
							</div>
						</div>
						<div className="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
							<SwiperSlider />
						</div>
						
						
					</section>	
					{/* Section-3 End */ }

						
							
							{/*  Proximity to Landmarks Section */  }
							{/* <section className="content-inner-2 proximity-landmarks-section" data-content="Proximity to" style={{padding: '80px 0', background: 'linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)'}}>
								<div className="container">
									<div className="section-head text-center mb-5 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.1s">
										<h2 className="title" style={{fontSize: '42px', fontWeight: '700', color: '#333', marginBottom: '15px'}}>Proximity to Landmarks</h2>
										<div className="dlab-separator bg-primary" style={{width: '80px', height: '4px', margin: '0 auto 20px'}}></div>
										<p style={{fontSize: '16px', color: '#666', maxWidth: '600px', margin: '0 auto'}}>Conveniently located near major attractions and key destinations</p>
									</div>
									
									<div className="row justify-content-center">
										<div className="col-lg-3 col-md-4 col-sm-6 mb-4 wow fadeInUp" data-wow-delay="0.1s">
											<div className="landmark-card">
												<div className="landmark-card-icon">
													<i className="fa fa-plane" style={{fontSize: '32px', color: '#b8975f'}}></i>
												</div>
												<div className="landmark-card-time">15 Minutes</div>
												<div className="landmark-card-location">To Ajman City Center</div>
											</div>
										</div>
										<div className="col-lg-3 col-md-4 col-sm-6 mb-4 wow fadeInUp" data-wow-delay="0.2s">
											<div className="landmark-card">
												<div className="landmark-card-icon">
													<i className="fa fa-plane" style={{fontSize: '32px', color: '#b8975f'}}></i>
												</div>
												<div className="landmark-card-time">16 Minutes</div>
												<div className="landmark-card-location">to Sharjah International Airport</div>
											</div>
										</div>
										<div className="col-lg-3 col-md-4 col-sm-6 mb-4 wow fadeInUp" data-wow-delay="0.3s">
											<div className="landmark-card">
												<div className="landmark-card-icon">
													<i className="fa fa-plane" style={{fontSize: '32px', color: '#b8975f'}}></i>
												</div>
												<div className="landmark-card-time">25 Minutes</div>
												<div className="landmark-card-location">to Dubai Airport</div>
											</div>
										</div>
										<div className="col-lg-3 col-md-4 col-sm-6 mb-4 wow fadeInUp" data-wow-delay="0.4s">
											<div className="landmark-card">
												<div className="landmark-card-icon">
													<i className="fa fa-plane" style={{fontSize: '32px', color: '#b8975f'}}></i>
												</div>
												<div className="landmark-card-time">25 Minutes</div>
												<div className="landmark-card-location">to Al Marjan Island</div>
											</div>
										</div>
										<div className="col-lg-3 col-md-4 col-sm-6 mb-4 wow fadeInUp" data-wow-delay="0.5s">
											<div className="landmark-card">
												<div className="landmark-card-icon">
													<i className="fa fa-plane" style={{fontSize: '32px', color: '#b8975f'}}></i>
												</div>
												<div className="landmark-card-time">45 Minutes</div>
												<div className="landmark-card-location">to Dubai Mall / Burj Khalifa / Downtown</div>
											</div>
										</div>
										<div className="col-lg-3 col-md-4 col-sm-6 mb-4 wow fadeInUp" data-wow-delay="0.6s">
											<div className="landmark-card">
												<div className="landmark-card-icon">
													<i className="fa fa-plane" style={{fontSize: '32px', color: '#b8975f'}}></i>
												</div>
												<div className="landmark-card-time">55 Minutes</div>
												<div className="landmark-card-location">to Burj Al Arab</div>
											</div>
										</div>
										<div className="col-lg-3 col-md-4 col-sm-6 mb-4 wow fadeInUp" data-wow-delay="0.7s">
											<div className="landmark-card">
												<div className="landmark-card-icon">
													<i className="fa fa-plane" style={{fontSize: '32px', color: '#b8975f'}}></i>
												</div>
												<div className="landmark-card-time">10 Minutes</div>
												<div className="landmark-card-location">to Jumeirah Public Beach</div>
											</div>
										</div>
										<div className="col-lg-3 col-md-4 col-sm-6 mb-4 wow fadeInUp" data-wow-delay="0.8s">
											<div className="landmark-card">
												<div className="landmark-card-icon">
													<i className="fa fa-plane" style={{fontSize: '32px', color: '#b8975f'}}></i>
												</div>
												<div className="landmark-card-time">55 Minutes</div>
												<div className="landmark-card-location">to Palm Jumeirah</div>
											</div>
										</div>
									</div>
								</div>
								
								<style>{`
									.proximity-landmarks-section {
										position: relative;
									}
									.landmark-card {
										background: #ffffff;
										border-radius: 15px;
										padding: 22px 6px;
										text-align: center;
										box-shadow: 0 5px 25px rgba(0, 0, 0, 0.08);
										transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
										border: 1px solid rgba(227, 144, 1, 0.1);
										height: 100%;
										display: flex;
										flex-direction: column;
										align-items: center;
										justify-content: center;
										position: relative;
										overflow: hidden;
									}
									.landmark-card::before {
										content: '';
										position: absolute;
										top: 0;
										left: 0;
										right: 0;
										height: 4px;
										background: linear-gradient(90deg, #b8975f, #b8975f);
										transform: scaleX(0);
										transition: transform 0.4s ease;
									}
									.landmark-card:hover {
										transform: translateY(-10px);
										box-shadow: 0 15px 40px rgba(227, 144, 1, 0.2);
										border-color: rgba(227, 144, 1, 0.3);
									}
									.landmark-card:hover::before {
										transform: scaleX(1);
									}
									.landmark-card-icon {
										width: 54px;
										height: 54px;
										border-radius: 50%;
										background: linear-gradient(135deg, rgba(227, 144, 1, 0.1), rgba(184, 148, 31, 0.1));
										display: flex;
										align-items: center;
										justify-content: center;
										margin-bottom: 20px;
										transition: all 0.4s ease;
									}
									.landmark-card:hover .landmark-card-icon {
										background: linear-gradient(135deg, #b8975f, #b8975f);
										transform: scale(1.1) rotate(5deg);
									}
									.landmark-card:hover .landmark-card-icon i {
										color: #ffffff !important;
									}
									.landmark-card-time {
										font-size: 28px;
										font-weight: 700;
										color: #333;
										margin-bottom: 10px;
										transition: color 0.3s ease;
									}
									.landmark-card:hover .landmark-card-time {
										color: #b8975f;
									}
									.landmark-card-location {
										font-size: 15px;
										color: #666;
										line-height: 1.6;
										font-weight: 500;
									}
									@media (max-width: 768px) {
										.landmark-card {
											padding: 30px 20px;
										}
										.landmark-card-icon {
											width: 54px;
											height: 54px;
										}
										.landmark-card-time {
											font-size: 24px;
										}
									}
								`}</style>
							</section> */}



	{/*  Our Projects Section */}
	{/* <section className="content-inner projects-section" data-content="OUR PROJECTS" style={{padding: '80px 0', backgroundColor: '#fff'}}>
							<div className="container">
								<div className="section-head text-center mb-5 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.1s">
									<h2 className="title" style={{fontSize: '42px', fontWeight: '700', color: '#333', marginBottom: '20px'}}>Our Projects</h2>
								</div>
								
							
								<div className="row mb-4 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
									<div className="col-12">
										<div className="site-filters filter-style1 clearfix m-b20 text-center">
											<ul className="filters" data-toggle="buttons" style={{justifyContent: 'center'}}>
												<ProjectTagLi label="Completed and Delivered" value="completed" handleSetTab={this.handleTabChange} tabActive={this.state.activeTab === 'completed'} />
												<ProjectTagLi label="Ongoing" value="ongoing" handleSetTab={this.handleTabChange} tabActive={this.state.activeTab === 'ongoing'} />
											</ul>
										</div>
									</div>
								</div>
								
								<div className="row wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
									{this.state.activeTab === 'completed' && (
										<>
											<div className="col-md-3 mb-4">
												<div className="project-image-box" style={{
													position: 'relative',
													width: '100%',
													height: '400px',
													overflow: 'hidden',
													borderRadius: '10px',
													boxShadow: '0 5px 20px rgba(0,0,0,0.1)'
												}}>
													<img 
														src={towera} 
														alt="Goldcrest Tower A" 
														style={{
															width: '100%',
															height: '100%',
															objectFit: 'cover'
														}}
													/>
													<div style={{
														position: 'absolute',
														bottom: '20px',
														left: '20px',
														right: '20px'
													}}>
														<Link 
															to="/goldcrest-dream-tower-a" 
															className="btn btn-primary"
															style={{
																backgroundColor: '#b8975f',
																border: 'none',
																padding: '12px 30px',
																borderRadius: '5px',
																color: '#fff',
																fontWeight: '600',
																textDecoration: 'none',
																display: 'inline-block',
																transition: 'all 0.3s ease'
															}}
															onMouseEnter={(e) => e.target.style.backgroundColor = '#b8975f'}
															onMouseLeave={(e) => e.target.style.backgroundColor = '#b8975f'}
														>
															Goldcrest Tower A
														</Link>
													</div>
												</div>
											</div>
											<div className="col-md-3 mb-4">
												<div className="project-image-box" style={{
													position: 'relative',
													width: '100%',
													height: '400px',
													overflow: 'hidden',
													borderRadius: '10px',
													boxShadow: '0 5px 20px rgba(0,0,0,0.1)'
												}}>
													<img 
														src={towerb} 
														alt="Goldcrest Tower B" 
														style={{
															width: '100%',
															height: '100%',
															objectFit: 'cover'
														}}
													/>
													<div style={{
														position: 'absolute',
														bottom: '20px',
														left: '20px',
														right: '20px'
													}}>
														<Link 
															to="/goldcrest-dream-tower-b" 
															className="btn btn-primary"
															style={{
																backgroundColor: '#b8975f',
																border: 'none',
																padding: '12px 30px',
																borderRadius: '5px',
																color: '#fff',
																fontWeight: '600',
																textDecoration: 'none',
																display: 'inline-block',
																transition: 'all 0.3s ease'
															}}
															onMouseEnter={(e) => e.target.style.backgroundColor = '#b8975f'}
															onMouseLeave={(e) => e.target.style.backgroundColor = '#b8975f'}
														>
															Goldcrest Tower B
														</Link>
													</div>
												</div>
											</div>
											<div className="col-md-3 mb-4">
												<div className="project-image-box" style={{
													position: 'relative',
													width: '100%',
													height: '400px',
													overflow: 'hidden',
													borderRadius: '10px',
													boxShadow: '0 5px 20px rgba(0,0,0,0.1)'
												}}>
														<img 
														src={views1} 
														alt="Goldcrest Views 1" 
														style={{
															width: '100%',
															height: '100%',
															objectFit: 'cover'
														}}
													/>
													<div style={{
														position: 'absolute',
														bottom: '20px',
														left: '20px',
														right: '20px'
													}}>
														<Link 
															to="/portfolio-1" 
															className="btn btn-primary"
															style={{
																backgroundColor: '#b8975f',
																border: 'none',
																padding: '12px 30px',
																borderRadius: '5px',
																color: '#fff',
																fontWeight: '600',
																textDecoration: 'none',
																display: 'inline-block',
																transition: 'all 0.3s ease'
															}}
															onMouseEnter={(e) => e.target.style.backgroundColor = '#b8975f'}
															onMouseLeave={(e) => e.target.style.backgroundColor = '#b8975f'}
														>
															Goldcrest Views 1
														</Link>
													</div>
												</div>
											</div>
											<div className="col-md-3 mb-4">
												<div className="project-image-box" style={{
													position: 'relative',
													width: '100%',
													height: '400px',
													overflow: 'hidden',
													borderRadius: '10px',
													boxShadow: '0 5px 20px rgba(0,0,0,0.1)'
												}}>
													<img 
														src={views2} 
														alt="Goldcrest Views 2" 
														style={{
															width: '100%',
															height: '100%',
															objectFit: 'cover'
														}}
													/>
													<div style={{
														position: 'absolute',
														bottom: '20px',
														left: '20px',
														right: '20px'
													}}>
														<Link 
															to="/portfolio-1" 
															className="btn btn-primary"
															style={{
																backgroundColor: '#b8975f',
																border: 'none',
																padding: '12px 30px',
																borderRadius: '5px',
																color: '#fff',
																fontWeight: '600',
																textDecoration: 'none',
																display: 'inline-block',
																transition: 'all 0.3s ease'
															}}
															onMouseEnter={(e) => e.target.style.backgroundColor = '#b8975f'}
															onMouseLeave={(e) => e.target.style.backgroundColor = '#b8975f'}
														>
															Goldcrest Views 2
														</Link>
													</div>
												</div>
											</div>
										</>
									)}
									
									{this.state.activeTab === 'ongoing' && (
										<>
											<div className="col-md-3 mb-4">
												<div className="project-image-box" style={{
													position: 'relative',
													width: '100%',
													height: '400px',
													overflow: 'hidden',
													borderRadius: '10px',
													boxShadow: '0 5px 20px rgba(0,0,0,0.1)'
												}}>
													<img 
														src={TowerC} 
														alt="Goldcrest Dreams Tower C" 
														style={{
															width: '100%',
															height: '100%',
															objectFit: 'cover'
														}}
													/>
													<div style={{
														position: 'absolute',
														bottom: '20px',
														left: '20px',
														right: '20px'
													}}>
														<Link 
															to="/goldcrest-dream-tower-c" 
															className="btn btn-primary"
															style={{
																backgroundColor: '#b8975f',
																border: 'none',
																padding: '12px 30px',
																borderRadius: '5px',
																color: '#fff',
																fontWeight: '600',
																textDecoration: 'none',
																display: 'inline-block',
																transition: 'all 0.3s ease'
															}}
															onMouseEnter={(e) => e.target.style.backgroundColor = '#b8975f'}
															onMouseLeave={(e) => e.target.style.backgroundColor = '#b8975f'}
														>
															Goldcrest Dreams Tower C
														</Link>
													</div>
												</div>
											</div>
											<div className="col-md-3 mb-4">
												<div className="project-image-box" style={{
													position: 'relative',
													width: '100%',
													height: '400px',
													overflow: 'hidden',
													borderRadius: '10px',
													boxShadow: '0 5px 20px rgba(0,0,0,0.1)'
												}}>
													<img 
														src={executive} 
														alt="Goldcrest Dreams Tower D" 
														style={{
															width: '100%',
															height: '100%',
															objectFit: 'cover'
														}}
													/>
													<div style={{
														position: 'absolute',
														bottom: '20px',
														left: '20px',
														right: '20px'
													}}>
														<Link 
															to="/portfolio-1" 
															className="btn btn-primary"
															style={{
																backgroundColor: '#b8975f',
																border: 'none',
																padding: '12px 30px',
																borderRadius: '5px',
																color: '#fff',
																fontWeight: '600',
																textDecoration: 'none',
																display: 'inline-block',
																transition: 'all 0.3s ease'
															}}
															onMouseEnter={(e) => e.target.style.backgroundColor = '#b8975f'}
															onMouseLeave={(e) => e.target.style.backgroundColor = '#b8975f'}
														>
															Goldcrest Dreams Tower D
														</Link>
													</div>
												</div>
											</div>
										</>
									)}
									
									{this.state.activeTab === 'stargiga' && (
										<div className="col-12">
											<div style={{
												backgroundColor: 'black',
												padding: '60px 40px',
												borderRadius: '10px',
												textAlign: 'center'
											}}>
												<h3 style={{
													fontSize: '36px',
													fontWeight: '700',
													color: '#fff',
													marginBottom: '30px'
												}}>
													Discover More Projects by Star Giga
												</h3>
												<Link 
													to="/portfolio-1" 
													className="btn btn-primary"
													style={{
														backgroundColor: '#b8975f',
														border: 'none',
														padding: '15px 40px',
														borderRadius: '5px',
														color: '#fff',
														fontWeight: '600',
														fontSize: '18px',
														textDecoration: 'none',
														display: 'inline-block',
														transition: 'all 0.3s ease'
													}}
													onMouseEnter={(e) => e.target.style.backgroundColor = '#b8975f'}
													onMouseLeave={(e) => e.target.style.backgroundColor = '#b8975f'}
												>
													Explore GoldCrest
												</Link>
											</div>
										</div>
									)}
								</div>
							</div>
						</section> */}
						{/*  Our Projects Section End */}

							{/* redeifining excellence */}
							{/* <section className="content-inner about-box" data-content="ABOUT US" id="sidenav_aboutUs">	
							<div className="about-bg"></div>
							<div className="container">
								<div className="row">
									<div className="col-md-7 col-lg-6">
										<div className="section-head">
											<h2 className="title" >Redefining Excellence in Commercial</h2>
											<div className="dlab-separator bg-primary " ></div>
											<h4 className="mb-4" >Real Estate</h4>
											<p >
											At STAR GIGA, we craft world-class commercial spaces that blend innovation, functionality, and elegance. Whether you seek modern office towers, premium retail spaces, or dynamic business hubs, our projects are designed to elevate your brand and maximize growth. Explore our portfolio and secure your place in the future of business.
											</p>
											
										</div>
										<Link to={"/about-us-1"} className="btn btn-primary " >About Us</Link>
									</div>
									<div className="col-md-5 col-lg-6"></div>
								</div>
							</div>
						</section> */}
						
					
						
						{/*  Our Gallery */}
						{/* <section className="content-inner" data-content="PRICE TABLE">				
								<div className="container">
									<div className="section-head text-center">
										<p>VIEW PORTFOLLO</p>
										<h2 className="title">Don’t miss your chance to discover the most fascinating </h2>
										<p>Phasellus dolor risus, luctus at lorem eu, sollicitudin mollis leo. Pellentesque tincidunt vel tortor et cursus. Donec posuere risus vitae viverra cursus. Nunc porttitor pharetra elit id</p>
									</div>
									<SimpleReactLightbox>
										<SRLWrapper >
											<div className="row" id="lightgallery">
												<div className="col-md-12 col-lg-6">
													<div className="dlab-box gallery-box-1 m-b30 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.2s">
														<GalleryBox imageBlog={port1} />
													</div>
												</div>
												<div className="col-md-6 col-lg-3 col-sm-6">
													<div className="dlab-box gallery-box-1 m-b30 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.4s">
														<GalleryBox imageBlog={port2} />
													</div>
													<div className="dlab-box gallery-box-1 m-b30 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.6s">
														<GalleryBox imageBlog={port3} />
													</div>
												</div>
												<div className="col-md-6 col-lg-3 col-sm-6">
													<div className="dlab-box gallery-box-1 m-b30 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.8s">
														<GalleryBox imageBlog={port4} />
													</div>
													<div className="dlab-box gallery-box-1 m-b30 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.2s">
														<GalleryBox imageBlog={port5} />
													</div>
												</div>
											</div>
										</SRLWrapper>
									</SimpleReactLightbox>
								</div>
							</section> */}
							{/*  Our Gallery */}
						
							{/*  Counters  */}
							{/* <CounterSection /> */}
							{/*  Counters End */}
							
							{/*  Our Team  */}
							{/* <TeamSection /> */}
							{/*  Our Team End */}
							
							{/*  Our Partners */}
							{/* <SpondorSection /> */}
							{/*  Our Partners End*/}
						</div>
					</div>
					{/*  Content END */}
					



						{/* Video Section */}
						{/* <div className="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.1s">
							<VideoSection className="mb-6"/>
						</div> */}
							{/* Video Section End*/}



					{/* Section-7 Start - News & Event */}
					{/* <section className="content-inner-  mt-5 mb-5" data-content="NEWS & EVENT" id="sidenav_newsEvent">	
						<div className="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.1s">
							<EventSection />
						</div>
					</section>	 */}
					{/* Section-7 End */}
					
					<Footer2 />
				</Fragment>
			)
		}
	}
	export default Index2;